import { Injectable } from '@angular/core';
import { AbstractCRUD, CRUDService, ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { Domain } from '../../shared/models/domain.model';


@Injectable({
  providedIn: 'root'
})
export class DomainService extends AbstractCRUD<Domain> implements CRUDService<Domain> {

  private domainCache$: Observable<PaginatedList<Domain>>;

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService,
  ) {
    super(exceptionService, http, utilsService);
    this.utilsService = utilsService;
  }

  get domains() {
    if (!this.domainCache$) {
      this.domainCache$ = this.getAllDomains().pipe(shareReplay(1));
    }
    return this.domainCache$;
  }

  public getResourcePath(): string {
    return '/rms/domains';
  }

  public getAllDomains(): Observable<any> {
    return super.getHTTP().get(`${this.getApiPath()}?page=0&pagesize=5000&relevance=DEFAULT&relevance=COMPANY`, {})
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public addCompanyToDomain(companyId: number, domainId: number): Observable<any> {
    return super.getHTTP().put(`${this.utilsService.getAPIPath()}/rms/companies/${companyId}/domain/${domainId}/add`, {})
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public removeCompanyFromDomain(companyId: number, domainId: number): Observable<any> {
    return super.getHTTP().put(`${this.utilsService.getAPIPath()}/rms/companies/${companyId}/domain/${domainId}/remove`, {})
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

}
